// extracted by mini-css-extract-plugin
export default {"messageBlock":"MessageBlock_messageBlock__QyV1X","icon":"MessageBlock_icon__j2fHs","item":"MessageBlock_item__kvQen"};